export default {
      id: "Icon--gift-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--gift",
      toString: function () {
        return this.url;
      }
    }